import {config, http} from './__http';

export default {

    getSizeChartOptions(sizeCharts, params) {
        http.get(config.baseUrl()+'/sizechart').then(response => {
            sizeCharts(response.data)
        }).catch(e => {
            console.error(e);
        });
    },
    getSizeChart(sizeChart, id) {
        http.get(config.baseUrl()+'/sizechart/'+id).then(response => {
            sizeChart(response.data);
        }).catch(e => {
            console.error(e);
        });
    },
    createSizeChart(sizeChart, params) {
        http.post(config.baseUrl()+'/sizechart', params).then(response => {
            sizeChart(response.data);
        }).catch(e => {
            sizeChart(e.response);
        });
    },
    updateSizeChart(sizeChart, params) {
        http.put(config.baseUrl()+'/sizechart/'+params.Id, params).then(response => {
            sizeChart(response.data);
        }).catch(e => {
            sizeChart(e.response);
        });
    }
}


// WEBPACK FOOTER //
// ./src/api/SizeChart.js